<template>
  <v-dialog :model-value="modelValue" max-width="640" @update:model-value="$emit('update:modelValue', $event)">
    <v-card>
      <v-card-title>{{ form.id ? 'Пользователь' : 'Новый пользователь' }}</v-card-title>
      <v-card-text class="form-grid">
        <v-text-field v-model="form.login" label="Логин" autocomplete="off" />
        <v-text-field v-model="form.name" label="Имя" />
        <v-select v-model="form.status" :items="statuses" label="Статус" />
        <v-select v-model="form.roles" :items="roles" label="Роли" multiple chips />
        <v-text-field v-model="form.password" :label="form.id ? 'Новый пароль' : 'Пароль'" type="password" autocomplete="new-password" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="$emit('update:modelValue', false)">Отмена</v-btn>
        <v-btn color="primary" prepend-icon="mdi-content-save-outline" @click="$emit('save', form)">Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { reactive, watch } from 'vue';
const props = defineProps({ modelValue: Boolean, user: Object });
defineEmits(['update:modelValue', 'save']);
const roles = [
  { title: 'Супер администратор', value: 'admin' },
  { title: 'Психолог', value: 'psychologist' },
];
const statuses = [
  { title: 'Активен', value: 'active' },
  { title: 'Заблокирован', value: 'blocked' },
];
const form = reactive({ id: null, login: '', name: '', status: 'active', roles: ['psychologist'], password: '' });
watch(() => props.user, (value) => {
  Object.assign(form, { id: null, login: '', name: '', status: 'active', roles: ['psychologist'], password: '', ...(value || {}) });
  form.roles = [...(value?.roles || form.roles || [])];
  form.password = '';
}, { immediate: true });
</script>
